export default __webpack_public_path__ + "static/media/b36.86681d6f.png";